export const environment = {
  heading: 'Development',
  production: false,
  apiUrl: 'https://api.dev.gateway.tourboplus.com/v2/tourbook',
  xapikey: '123456',
  stylesUrl:
    'https://s3-flaptek-bucket-dev.s3.us-east-1.amazonaws.com/tourbookdev/scripts/styles.css',
};
